type ReverseGeocodeProps = {
	coordinatesInput: [number, number];
	accessToken: string;
};

export const reverseGeocode = async ({
	coordinatesInput,
	accessToken
}: ReverseGeocodeProps): Promise<string | null> => {
	try {
		let coordinates: [number, number];
		if (typeof coordinatesInput === 'string') {
			try {
				coordinates = JSON.parse(coordinatesInput); // Parse the string
				if (!Array.isArray(coordinates) || coordinates.length !== 2) {
					throw new Error('Parsed coordinates are not valid.');
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(
					'Failed to parse coordinates string:',
					coordinatesInput
				);
				return null;
			}
		} else {
			coordinates = coordinatesInput;
		}

		const [longitude, latitude] = coordinates;
		const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?types=place,region&access_token=${accessToken}`;

		// Make the API request using fetch
		const response = await fetch(url);

		if (response.status !== 200) {
			throw new Error(`Geocoding API error: ${response.statusText}`);
		}

		const data = await response.json();
		const { features } = data;

		// Extract city and state from the response
		const place = features.find((f: any) =>
			f.place_type.includes('place')
		)?.text;
		const region = features.find((f: any) =>
			f.place_type.includes('region')
		)?.text;

		if (place && region) {
			return `${place}, ${region}`; // Return "City, State"
		}

		return null; // Fallback if city or state is not found
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Reverse geocoding failed:', error);
		return null;
	}
};
